const configSsamTalk = {
    category: {
        listLayout: "SsamTalkListCategoryLayout",
        filterLayout: "SsamTalkFilterNoneLayou",
        paginationLayout: "PaginationNoDeleteLayout",

        getFunc: "getSsamTalkCategory",
        listApiParamSet: {
            ip: 1,
        },
        pageRow: 10,
        paginationType: "pagination",
        isCategory: false,
        deleteKeyName: "sc_idx",
        deleteFunc: "deleteSsamTalkCategory",
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            "-1": "정보를 삭제할 수 없습니다.",
        },
    },
    categoryBasic : {
        categoryApiParamsSet: {
            // type : 'all',
            // ct: 'basic',
            // cid: 30,
            // opp: 1,
            // opf: 1,
        },
        getFunc : "getSsamTalkCategory",
        // listApiParamSet: {
        //     ct: 'basic',
        // },
        writeFunc : "updateSsamTalkCategory",
        createFunc : "createSsamTalkCategory",
        deleteKeyName: "sc_idx",
        deleteFunc: "deleteSsamTalkCategory",
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
        keyName: 'sc_idx',
        ctType : 'basic'
    },
    categoryCreate: {
        getFunc: '',
        detailApiParamSet: {},
        writeLayouts: ["SsamTalkWriteCategoryLayout"],
        writeFunc: "createSsamTalkCategory",
        writeApiParamSet: {},
        parsingData: {
            name: 'sc_name',
            seq: 'sc_seq',
        },
        writeKeyName: 'sc_idx',
        fileInfo: [
            {
                fileName: 'files',
                fileType: 'ssamtalk_category',
            },
            {
                fileName: 'detailFiles',
                fileType: 'ssamtalk_category_detail',
            },
        ],

        isCategory: false,
        directUrl: "",
        directType: "back",
        writeSuccessType: 1,
        writeFailTypes: {
            "-1": "카테고리를 생성할 수 없습니다.",
            '-200': '중복된 카테고리명이 존재합니다.',
        },
        writeFailMsg: "카테고리 작성에 실패하였습니다.",
        deleteKeyName: "",
        deleteFunc: "",
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    categoryUpdate: {
        getFunc: 'getSsamTalkCategory',
        detailApiParamSet: {opf: 1, ip: 0},
        writeLayouts: ["SsamTalkWriteCategoryLayout"],
        writeFunc: "updateSsamTalkCategory",
        writeApiParamSet: {},
        parsingData: {
            name: 'sc_name',
            seq: 'sc_seq',
        },
        keyName: 'scid',
        writeKeyName: 'sc_idx',
        fileInfo: [
            {
                fileName: 'files',
                fileType: 'ssamtalk_category',
            },
            {
                fileName: 'detailFiles',
                fileType: 'ssamtalk_category_detail',
            },
        ],
        isCategory: false,
        directUrl: "",
        directType: "back",
        writeSuccessType: 1,
        writeFailTypes: {
            "-1": "카테고리를 생성할 수 없습니다.",
        },
        writeFailMsg: "카테고리 수정에 실패하였습니다.",
        deleteKeyName: "sc_idx",
        deleteFunc: "deleteSsamTalkCategory",
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },

    ssamtalk: {
        listLayout: "SsamTalkListDefaultLayout",
        filterLayout: "SsamTalkFilterDefaultLayou",
        paginationLayout: "PaginationDefaultLayout",
        getFunc: "getSsamTalk",
        getCategoryFunc: "getSsamTalkCategory",
        listApiParamSet: {
            ip: 1,
            type: 'content',
            opc: 1,
            sstin: [1, 2]
        },
        pageRow: 10,
        paginationType: "pagination",
        isCategory: true,
        deleteKeyName: "s_idx",
        deleteFunc: "deleteSsamTalk",
        deleteApiParamsSet: {
            type: 'content'
        },
        deleteSuccessType: 1,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },
    ssamtalkCreate: {
        getFunc: '',
        getCategoryFunc: "getSsamTalkCategory",
        detailApiParamSet: {opf: 1, ip: 0},
        writeLayouts: ["SsamTalkWriteDefaultLayout"],
        writeFunc: "createSsamTalk",
        writeApiParamSet: {
            type: 'content',
            s_type: 'video',
        },
        parsingData: {
            title: 's_title',
            content: 's_content',
            category: 'sc_idx',
            stepStatus:'s_have_step',
            subTitle:'sbv_title',
            subContent:'sbv_content',
            premium:'sbv_is_premium',
            files: '',
            videoFile: '',
        },
        writeKeyName: 's_idx',
        fileInfo: [
            {
                fileName: 'files',
                fileType: 'ssamtalk',
            },
            {
                fileName: 'bookFile',
                fileType: 'ssamtalk_book',
            },
        ],
        isCategory: true,
        isSetWriteVimeo: true,
        isSetReference: true,
        isMoveDetailStatus: true,
        directUrl: "",
        directType: "back",
        writeSuccessType: 1,
        writeFailTypes: {
            "-1": "컨텐츠를 생성할 수 없습니다.",
            "-300": "컨텐츠 제목이 존재하고있습니다.",
        },
        deleteKeyName: "s_idx",
        deleteFunc: "deleteSsamTalk",
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },
    ssamtalkUpdate: {
        getFunc: 'getSsamTalk',
        getCategoryFunc: "getSsamTalkCategory",
        detailApiParamSet: {
            type: 'content',
            opf: 1,
            opb: 1,
            opr: 1,
            // oppg: 1,
            // opc: 1,
            // ops: 1,
            // opsf: 1,
            // opse: 1,
            // opcc: 1,
            ip: 0,
            sstin: [1, 2],
        },
        writeLayouts: ["SsamTalkWriteDefaultLayout"],
        writeFunc: "updateSsamTalk",
        writeApiParamSet: {
            type: 'content',
        },
        parsingData: {
            title: 's_title',
            content: 's_content',
            category: 'sc_idx',
            stepStatus:'s_have_step',
            subTitle:'sbv_title',
            subContent:'sbv_content',
            premium:'sbv_is_premium',
            files: '',
            videoFile: '',
        },
        keyName: 'sid',
        writeKeyName: 's_idx',
        fileInfo: [
            {
                fileName: 'files',
                fileType: 'ssamtalk',
            },
            {
                fileName: 'bookFile',
                fileType: 'ssamtalk_book',
            },
        ],
        fileType: "ssamtalk",
        isCategory: true,
        isSetWriteVimeo: true,
        isSetReference: true,
        isMoveDetailStatus: false,
        directUrl: "",
        directType: "init",
        writeSuccessType: 1,
        writeFailTypes: {
            "-1": "컨텐츠를 수정할 수 없습니다.",
            "-300": "컨텐츠 제목이 존재하고있습니다.",
        },
        deleteAlertMsg: '콘텐츠를 삭제하시겠습니까? 삭제 후 복구 불가능합니다.',
        deleteKeyName: "s_idx",
        deleteFunc: "deleteSsamTalk",
        deleteApiParamsSet: {
            type: 'content'
        },
        deleteSuccessType: 1,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },

    ssamtalkStepInfo: {
        detailLayout: 'SsamTalkDetailStepListLayout',
        getFunc: 'getSsamTalk',
        detailApiParamSet: {
            type: 'content',
            opf: 1,
            opb: 1,
            opr: 1,
            ip: 0,
            sstin: [1, 2],
            ops:1,
        },
        keyName: 'sid',
        deleteAlertMsg: '삭제시 해당 콘텐츠가 삭제되며 복구 불가합니다.<br>앱에서는 해당 건에 대해 성적만 확인 가능합니다. 삭제하시겠습니까?',
        deleteKeyName: "s_idx",
        deleteFunc: "deleteSsamTalk",
        deleteApiParamsSet: {
            type: 'content'
        },
        deleteSuccessType: 1,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },
    step: {
        listLayout: "SsamTalkListStepLayout",
        filterLayout: "SsamTalkFilterNoneLayout",
        paginationLayout: "PaginationNoneLayout",
        getFunc: "getSsamTalk",
        getCategoryFunc: "getSsamTalkCategory",
        listApiParamSet: {
            ip: 0,
            type: 'step',
            opd: 1,
            odc: 'ss_idx',
            odd: 'asc',
        },
        keyName:'sid',
        pageRow: 10,
        paginationType: "pagination",
        deleteKeyName: "ss_idx",
        deleteFunc: "deleteSsamTalk",
        deleteApiParamsSet: {
            type: 'step'
        },
        deleteSuccessType: 400,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },
    stepFinish: {
        listLayout: "SsamTalkListStepLayout",
        filterLayout: "SsamTalkFilterNoneLayout",
        paginationLayout: "PaginationNoneLayout",
        getFunc: "getSsamTalk",
        getCategoryFunc: "getSsamTalkCategory",
        listApiParamSet: {
            ip: 0,
            type: 'step',
            opd: 1,
            odc: 'ss_seq',
            odd: 'asc',
        },
        keyName:'sid',
        pageRow: 10,
        paginationType: "pagination",
        deleteKeyName: "ss_idx",
        deleteFunc: "deleteSsamTalk",
        deleteApiParamsSet: {
            type: 'step'
        },
        deleteSuccessType: 400,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },
    stepCreate: {
        getFunc: 'getSsamTalk',
        detailApiParamSet: {},
        writeLayouts: ["SsamTalkWriteStepLayout"],
        writeFunc: "createSsamTalk",
        writeApiParamSet: {
            type: 'step',
        },
        fileType: "ssamtalk",
        directType: "modal",
        directUrl: "ssamtalk-step-modal",
        writeSuccessType: 1,
        writeFailTypes: {
            "-112": "중복되는 숫자입니다.",
        },
        deleteKeyName: "ss_idx",
        deleteFunc: "deleteSsamTalk",
        deleteApiParamsSet: {
            type: 'step'
        },
        deleteSuccessType: 400,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },
    stepUpdate: {
        getFunc: 'getSsamTalk',
        detailApiParamSet: {
            type:'step',
            opd:1,
            opf:1,
        },
        writeLayouts: ["SsamTalkWriteStepLayout"],
        writeFunc: "updateSsamTalk",
        writeApiParamSet: {
            type: 'step',
        },
        fileType: "ssamtalk",
        directType: "modal",
        directUrl: "ssamtalk-step-modal",
        writeSuccessType: 1,
        writeFailTypes: {
            "-112": "중복되는 숫자입니다.",
        },
        deleteKeyName: "ss_idx",
        deleteFunc: "deleteSsamTalk",
        deleteApiParamsSet: {
            type: 'step'
        },
        deleteSuccessType: 400,
        deleteFailTypes: {
            "-1": "삭제에 실패하였습니다.",
        },
    },

};

export default {
    methods: {
        returnSsamTalkConfig(type) {
            return configSsamTalk[type];
        },
    },
    filterConfig: {
        cr: {
            type: "between",
            classname: "filterDate",
        },
        sti: {
            type: "query",
            classname: "searchInput",
        },
        sc_name: {
            type: "query",
            classname: "searchInput",
        },
        scid: {
            type: "match",
            classname: "filterCate",
        },
        sstin: {
            type: 'terms',
            classname: 'filterStatus',
            option: {
                0: [0, 1],
                1: [1],
                2: [2],
            },
        }
    },
};
